import { Column } from "../objects/column";
import { FunnelProductsParameter, FunnelProductsParameterForm, FunnelProductsParameterFormLocalization, FunnelProductsParameterListConfiguration, FunnelProductsParameterListCriteria, FunnelProductsParameterListFiltersCriteria, MarginCalculationMode } from "../objects/funnelProductsParameter";

export const EMPTY_FUNNEL_PRODUCTS_PARAMETER_LOCALIZATION: FunnelProductsParameterFormLocalization = {
    locale: 0,
    name: '',
};
export const EMPTY_FUNNEL_PRODUCTS_PARAMETER_FORM: FunnelProductsParameterForm = {
    name: '',
    name_localized: {},
    localization: [],
    allow_all_destination: true,
    destinations: [],
    room_selection_strategy: null,
    room_selection_strategy_by_price: null,
    room_selection_strategy_by_margin: null,
    room_selection_strategy_by_providers: [],
    refundable: null,
    selected_meal_plans: [],
    resort_fees: null,
    room_number: null,
    provider_display_mode: null,
};
export const EMPTY_FUNNEL_PRODUCTS_PARAMETER: FunnelProductsParameter = {
    name: '',
    localization: [],
    allow_all_destination: true,
    destinations: [],
    room_selection_strategy: null,
    room_selection_strategy_by_price: null,
    room_selection_strategy_by_margin: null,
    room_selection_strategy_by_providers: [],
    refundable: null,
    selected_meal_plans: [],
    resort_fees: null,
    room_number: null,
    provider_display_mode: null,
    allow_all_destination: true
};
export const EMPTY_FUNNEL_PRODUCTS_PARAMETER_FILTERS: FunnelProductsParameterListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};
export const EMPTY_FUNNEL_PRODUCTS_PARAMETER_LIST_CRITERIA: FunnelProductsParameterListCriteria = {
    limit: 50,
    page: 0,
    search: '',
    filters: EMPTY_FUNNEL_PRODUCTS_PARAMETER_FILTERS,
    order: "asc",
    order_by: ""
};


export const DEFAULT_COLUMN: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'destinations',
    field_name: 'DESTINATIONS',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: false,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const EMPTY_FUNNEL_PRODUCTS_PARAMETER_LIST_CONFIGURATION: FunnelProductsParameterListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const FUNNEL_PRODUCTS_PARAMETER_MODULE = 'CIRCUIT_FUNNEL_PRODUCTS_PARAMETER';
